<template>
  <main class="oauth-result">
    <section class="oauth-card">
      <div :class="['status-icon', status]">{{ status === "success" ? "✓" : status === "error" ? "!" : "…" }}</div>
      <h1>{{ title }}</h1>
      <p>{{ message }}</p>
      <button v-if="status !== 'loading'" @click="$router.push({ name: 'integrations' })">
        العودة إلى التكاملات
      </button>
    </section>
  </main>
</template>
  
  <script>
  import apiClient from "@/core/buildRequest";
  
  export default {
    name: "InstagramRedirectView",
    data() {
      return {
        code: "",
        status: "loading",
        title: "جاري ربط Instagram",
        message: "يرجى الانتظار...",
      };
    },
    mounted() {
      this.getInstagramToken();
    },
    methods: {
      async getInstagramToken() {
        const { code, state, error, error_description: errorDescription } = this.$route.query;
        this.code = code || "";

        if (!state) {
          this.setError("تعذر التحقق من حالة الربط. يرجى بدء عملية ربط جديدة.");
          return;
        }

        const params = [];
        const addParam = (key, value) =>
          params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value || "")}`);

        // Provider errors take precedence over a code and are reported to the backend as-is.
        addParam("state", state);
        addParam("error", error);
        addParam("error_description", errorDescription);
        if (!error) addParam("code", code);

        if (!error && !code) {
          this.setError("لم يتم العثور على رمز التحقق.");
          return;
        }

        try {
          const response = await apiClient.get(`/auth/instagram/callback?${params.join("&")}`);
          const credentials = response.data?.data?.credentials || {};

          if (credentials.access_token) localStorage.setItem("instagram_token", credentials.access_token);
          if (credentials.expire_date) localStorage.setItem("instagramTokenExpireAt", credentials.expire_date);

          if (error) {
            this.setError(response.data?.msg || errorDescription || error);
            return;
          }

          this.status = "success";
          this.title = "تم ربط Instagram بنجاح";
          this.message = response.data?.msg || "يمكنك الآن استخدام حساب Instagram الخاص بك.";
          this.redirectToIntegrations();
        } catch (requestError) {
          this.setError(requestError.response?.data?.msg || requestError.message);
        }
      },
      setError(message) {
        this.status = "error";
        this.title = "فشل ربط Instagram";
        this.message = message || "تعذر إكمال عملية الربط. يرجى المحاولة مرة أخرى.";
        this.redirectToIntegrations();
      },
      redirectToIntegrations() {
        window.setTimeout(() => this.$router.push({ name: "integrations" }), 3000);
      },
    },
  };
  </script>

<style scoped>
.oauth-result { min-height: 100vh; display: grid; place-items: center; padding: 24px; background: #f6f8f8; }
.oauth-card { width: min(100%, 440px); padding: 36px; text-align: center; border-radius: 16px; background: #fff; box-shadow: 0 12px 32px rgba(0,0,0,.12); }
.status-icon { width: 52px; height: 52px; margin: 0 auto 16px; display: grid; place-items: center; border-radius: 50%; font-size: 28px; font-weight: 700; }
.status-icon.success { color: #fff; background: #237276; }.status-icon.error { color: #fff; background: #cc0000; }.status-icon.loading { color: #237276; background: #e4f1f0; }
h1 { font-size: 22px; margin: 0 0 10px; } p { color: #52616b; line-height: 1.5; } button { padding: 10px 18px; border: 0; border-radius: 8px; color: #fff; background: #237276; cursor: pointer; }
</style>
